import React from "react";
import ReactModal from "react-modal";
import { FormattedMessage, useIntl } from "gatsby-plugin-intl";
import { useModalHelpers } from "hooks/modalHelpers";
import PageSection from "components/PageSection";
import headsets from "icons/headsets.svg";
import envelopeWhite from "icons/envelope-white.svg";
import chevronRight from "icons/chevron-right-white.svg";
import phone from "icons/phone-white.svg";
import modalPattern from "images/patterns/modal-pattern.svg";
import { gtagsActions, gtagsCategories, gtagsSend } from "utils/gtagsUtils";
import I18nWrapper from "components/I18nWrapper";
import Button from "components/Button";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ContactForm from "./ContactForm";

const ContactUs = () => {
  const modalHelpers = useModalHelpers();
  const { formatMessage } = useIntl();

  return (
    <PageSection
      id="contact-us"
      startIconTo="contact-us"
      className="py-40"
      pattern={null}
    >
      <div className="container w-full">
        <div className="mb-16 text-center">
          <h1
            className="text-black text-4xl mb-4"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: formatMessage({ id: "contact.title" }),
            }}
          />

          <p className="text-xl flex justify-center flex-wrap">
            <span className="rtl:ml-2 ltr:mr-2">
              <FormattedMessage id="contact.text.part1" />
            </span>
          </p>
        </div>

        <div className="flex flex-wrap justify-around w-full lg:w-9/12 xl:w-7/12 mx-auto">
          <a
            href="tel:0522421800"
            className="flex items-center rounded-full p-2 bg-white shadow-md w-full md:w-96 mb-8 md:mb-0"
            onClick={() =>
              gtagsSend(gtagsCategories.CONTACT, gtagsActions.CONTACT_PHONE)}
          >
            <div className="flex justify-center items-center h-16 w-16 rounded-full bg-secondary ltr:mr-3 rtl:ml-3">
              <object data={headsets} aria-label=" " width="35" />
            </div>

            <div>
              <div className="text-base">
                <FormattedMessage id="contact.callUs" />
              </div>

              <div dir="ltr" className="text-2xl text-secondary">
                05 22 42 18 00
              </div>
            </div>

            <div className="flex justify-center items-center h-12 w-12 rounded-full bg-primary ltr:ml-auto rtl:mr-auto ltr:mr-2 rtl:ml-2">
              <object
                className="pointer-events-none"
                data={phone}
                aria-label=" "
                width="18"
              />
            </div>
          </a>

          <a
            onClick={e => {
              gtagsSend(gtagsCategories.CONTACT, gtagsActions.CONTACT_EMAIL);
              e.preventDefault();
              modalHelpers.setModal("CONTACT_MODAL");
            }}
            href="#contact-us"
            className="flex items-center rounded-full p-2 bg-white shadow-md w-full md:w-96"
          >
            <div className="flex justify-center items-center h-16 w-16 rounded-full bg-secondary ltr:mr-3 rtl:ml-3">
              <object data={envelopeWhite} aria-label=" " width="27" />
            </div>

            <div>
              <div className="text-md">
                <FormattedMessage id="contact.sendUsAnEmail" />
              </div>
            </div>

            <div className="flex justify-center items-center h-12 w-12 rounded-full bg-primary ltr:ml-auto rtl:mr-auto ltr:mr-2 rtl:ml-2">
              <object
                className="pointer-events-none transform rtl:rotate-180"
                data={chevronRight}
                aria-label=" "
                width="8"
              />
            </div>
          </a>
        </div>
      </div>

      <ReactModal
        style={{
          content: {
            width: 700,
            backgroundImage: `url(${modalPattern})`,
          },
          overlay: {
            background: "rgba(0, 0, 0, 0.45)",
          },
        }}
        className="react-modal"
        onRequestClose={() => modalHelpers.clearModal()}
        isOpen={modalHelpers.isOpen("CONTACT_MODAL")}
      >
        <I18nWrapper>
          <div className="flex">
            <Button
              onClick={() => modalHelpers.clearModal()}
              className="text-md p-2 ml-auto outline-none"
            >
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          </div>
          <ContactForm onClose={() => modalHelpers.clearModal()} />
        </I18nWrapper>
      </ReactModal>
    </PageSection>
  );
};

export default ContactUs;
